import { Component, computed, inject, input, OnInit, signal } from '@angular/core';
import { ConfigResource } from '@df/catalog/config/config.resource';
import type { IProductDataV3 } from '@df/catalog/product/product';
import { BgContrastDirective } from '@df/ui/atomic/atom/color/bg-contrast.directive';
import { OptionColorPipe } from '@df/ui/common/option-color.pipe';
import { OptionLabelPipe } from '@df/ui/common/option-label.pipe';
import { CountdownComponent } from '@df/ui/display/countdown.component';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsConfig } from '@icms/core/resource/config/icms-config';
import { NProductViewLayout, Product } from '../product.decorator';
import { CMS_CONFIG_PRODUCT_SALE_BANNER, IICmsConfigProductSaleBannerData } from './sale-banner.cms-config';

@Component({
    selector: 'product-sale-banner',
    templateUrl: './sale-banner.html',
    standalone: true,
    imports: [BgContrastDirective, CountdownComponent, OptionColorPipe, OptionLabelPipe, TranslatePipe]
})
export class ProductSaleBannerComponent extends UiComponent implements OnInit {
    protected readonly product = input.required<Product<IProductDataV3>>();
    protected readonly content = input.required<NProductViewLayout.IBlockDataContent>();
    protected readonly fullWidth = input<boolean>(false);

    private config = signal<ICmsConfig<IICmsConfigProductSaleBannerData> | undefined>(undefined);
    private isActive = signal(false);

    protected readonly canShow = computed(() => {
        return (this.isActive() && this.label()?.endDate) || (!this.label() && this.product()?.data?.sale_banner);
    });

    protected readonly label = computed(() => {
        return this.config()?.data?.content.labels.find(label => label.option === this.product()?.data?.sale_banner && label.enable);
    });

    private readonly configResource = inject(ConfigResource);

    override async ngOnInit(): Promise<void> {
        super.ngOnInit();

        await this.configResource.loadModelByUrl(CMS_CONFIG_PRODUCT_SALE_BANNER);
        const config = this.configResource.getModelByUrl(
            CMS_CONFIG_PRODUCT_SALE_BANNER
        ) as any as ICmsConfig<IICmsConfigProductSaleBannerData>;
        this.config.set(config);
        this.detectChanges();
    }

    protected handleIsActive(isActive: boolean): void {
        this.isActive.set(isActive);
        this.detectChanges();
    }
}
